
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
  } from 'vuex-class';
  import UserNavigation from '@/components/User/UserNavigation.vue';
  import Toolbar from '@/modules/common/ui/_components/Toolbar.vue';

  @Component({
    components: {
      Toolbar,
      UserNavigation,
    },
  })
  export default class UserLayout extends Vue {
    @Action('guest/auth/signOut') private storeSignOut!: () => Promise<void>;
    @Action('guest/auth/loadUser') private loadUser!: any;

    private signOut(): void {
      this.storeSignOut().then(() => {
        this.$router.push({name: 'GuestHome'});
      });
    }

    private created() {
      this.loadUser();
    }
  }
